import { useState, useEffect, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./ExposeNFinalLesson.module.css";
import * as PathRouter from '../../../models/PathRoute'
import { NavLink } from "react-router-dom";
import { lessonsApi } from '../../../utils'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import AssessmentIcon from '../../../assests/lesson/assessment.png';
import UnAssessmentIcon from '../../../assests/lesson/unassessment.png';
import EyeIcon from '../../../assests/lesson/eye on.png';
import LockIcon from '../../../assests/lesson/lock.png';
import EyeColorIcon from '../../../assests/lesson/eye on color.png';
import EyeOffIcon from '../../../assests/lesson/eye off.png';
import EyeOffColorIcon from '../../../assests/lesson/eye off color.png';
import LockColorIcon from '../../../assests/lesson/lock color.png';
import UnLockColorIcon from '../../../assests/lesson/unlock color.png';
import UnLockIcon from '../../../assests/lesson/unlock.png';
import ScheduleColorIcon from '../../../assests/lesson/schedule color.png';
import ScheduleIcon from '../../../assests/lesson/schedule.png';
import moment from "moment";
import DatePickerExposeNFinalLesson from "./DatePickerExposeNFinalLesson";
import { onKeyDown } from "../../../service";
import { useLocation } from "react-router-dom";

const ExposeNFinalLesson = forwardRef(({ lessonDetails, visible, handleChangeExposure, changeLesson }, ref) => {

    const [checkedExposure, setCheckedExposure] = useState(null)
    const [checkedLock, setCheckedLock] = useState(null)
    const [activeFromDate, setActiveFromDate] = useState();
    const [showDatePicker, setShowDatePicker] = useState(false);

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector((state) => state.application.homeUrl);
    const dispatch = useDispatch()

    const lock = [{ name: "lock", icon: LockColorIcon, defaultChecked: checkedLock === "lock" }, { name: "lockTill", icon: ScheduleColorIcon, defaultChecked: checkedLock === "lockTill" }, { name: "unlock", icon: UnLockColorIcon, defaultChecked: checkedLock === "unlock" }]
    const show = [{ name: "showNow", icon: EyeColorIcon, defaultChecked: checkedExposure }, { name: "dontShow", icon: EyeOffColorIcon, defaultChecked: !checkedExposure }]
    const location = useLocation();

    useEffect(() => {
        setCheckedExposure(visible)
    }, [visible])

    useEffect(() => {
        if (!lessonDetails) return;
        if (lessonDetails.activeFromDate) {
            setCheckedLock("lockTill")
            setActiveFromDate(new Date(lessonDetails.activeFromDate))
        } else {
            setActiveFromDate(new Date());
            if (lessonDetails.active) {
                setCheckedLock("unlock")
            }
            else {
                setCheckedLock("lock")
            }
        }
    }, [lessonDetails])

    const handleSetCheckedExposure = () => {
        let data = {
            id: lessonDetails.id,
            name: lessonDetails.name,
            description: lessonDetails.description,
            active: lessonDetails.active,
            visible: !checkedExposure,
            activeFromDate: lessonDetails.activeFromDate,
        };

        if (data.activeFromDate) {
            let date = new Date(data.activeFromDate);
            let hours = date.getTimezoneOffset() / -60;
            data.activeFromDate = new Date(date.setHours(date.getHours() + hours));
        }
        lessonsApi.lessonsUpdatePost({ lessonUpdateInput: data }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.lessonsUpdateError, error: error, statusCode: response?.statusCode, message: "lessonsUpdatePost " + error.message, level: 2, component: "ExposeNFinalLesson", line: 24 }))
            else {
                handleChangeExposure(!checkedExposure)
                setCheckedExposure(!checkedExposure)
            }
        })
    }

    const handleSetCheckedLock = (e) => {
        let data = { ...lessonDetails, active: e.target.value === "unlock", activeFromDate: null };
        let dataToApi = {
            id: lessonDetails.id,
            name: lessonDetails.name,
            description: lessonDetails.description,
            active: e.target.value === "unlock",
            visible: lessonDetails.visible
        };

        if (e.target.value === "lockTill") {
            let date = new Date(activeFromDate);
            let hours = date.getTimezoneOffset() / -60;
            dataToApi.activeFromDate = new Date(date.setHours(date.getHours() + hours));
            data.activeFromDate = new Date(activeFromDate);
        }
        lessonsApi.lessonsUpdatePost({ lessonUpdateInput: dataToApi }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.lessonsUpdateError, error: error, statusCode: response?.statusCode, message: "lessonsUpdatePost " + error.message, level: 2, component: "ExposeNFinalLesson", line: 78 }))
            else {
                setCheckedLock(e.target.value);
                changeLesson(data);
            }
        })
    }

    const openDatePickerPopup = (e) => {
        e.stopPropagation();
        setShowDatePicker(true);
    }

    const renderTitle = (title, icon) => {
        return (
            <div className={classes.TitleContainer}>
                <img src={icon} alt="Icon" />
                <h2 className={classes.Title}>{title}:</h2>
            </div>
        )
    }

    const renderRadioInput = (x, name, handleChange) => {
        return (
            <label key={x.name} className={classes.RadioLabel} htmlFor={x.name}>
                <input className={classes.RadioInput} type="radio" id={x.name} name={name} value={x.name} defaultChecked={x.defaultChecked} onChange={handleChange}
                //  onKeyDown={e => onKeyDown(e, handleChange)} 
                />
                <span className={classes.RadioSpan}
                    tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleChange({ target: { value: x.name } }))}
                ></span>
                {texts[x.name]}
                <img src={x.icon} className={classes.RadioImg} alt="RadioIcon" />
                {x.name === "lockTill" && <button className={classes.RadioDate} onClick={(e) => openDatePickerPopup(e)}>{moment(activeFromDate).format('DD.MM.YYYY | HH:mm')}</button>}
            </label>
        )
    }


    return (
        <div className={classes.ExposeNFinalLesson}>
            <div className={classes.ExposureAndLabeling}>
                {checkedLock && <div>
                    <div className={classes.Container}>
                        {renderTitle(texts.locking, LockIcon)}
                        <h3 className={classes.InputText}>{texts.wandToAddAccess}</h3>
                        {lessonDetails && lock.map(x => renderRadioInput(x, "lock", handleSetCheckedLock))}
                    </div>
                    <div className={classes.Container}>
                        {renderTitle(texts.showOnMap, EyeIcon)}
                        <h3 className={classes.InputText}>{texts.wantToExposeNow}</h3>
                        {show.map(x => renderRadioInput(x, "show", handleSetCheckedExposure))}
                    </div>
                    {renderTitle(texts.assessment, AssessmentIcon)}
                    <div className={classes.ManageAssessments}>
                        <p className={classes.EditAssessmentText}>{texts.manageAssessments}</p>
                        <NavLink className={classes.EditAssessment} to={`${homeUrl}/${PathRouter.COURSES}/${lessonDetails.studyGroupId}`}>
                            <p className={classes.EditAssessmentTextUnderline}>{texts.pressHere}</p>
                        </NavLink>
                    </div>
                </div>}
                {showDatePicker && <DatePickerExposeNFinalLesson activeFromDate={activeFromDate} setActiveFromDate={setActiveFromDate} setShowDatePicker={setShowDatePicker} handleSetCheckedLock={handleSetCheckedLock} />}
            </div>
            <div className={classes.MyLesson}>
                <h2 className={classes.Title}>{texts.myLesson}</h2>
                <div className={classes.MyLessonInfo}>
                    <img className={classes.MyLessonInfoImg} src={checkedLock === "lock" ? LockIcon : checkedLock === "lockTill" ? ScheduleIcon : UnLockIcon} alt="icon" />
                    <div className={classes.MyLessonInfoText}>
                        {texts.theLesson}
                        <div className={classes.Highlight}>{checkedLock === "unlock" ? texts.unlock : texts.lock}</div>
                        {checkedLock === "lockTill" && moment(activeFromDate).format(texts.openInDate)}.
                    </div>
                </div>
                <div className={classes.MyLessonInfo}>
                    <img className={classes.MyLessonInfoImg} src={checkedExposure ? EyeIcon : EyeOffIcon} alt="icon" />
                    <div className={classes.MyLessonInfoText}>
                        {texts.theLesson}
                        <div className={classes.Highlight}>{checkedExposure ? texts.willShowOnMap : texts.willUnShowOnMap}</div>.
                    </div>
                </div>
                <div className={classes.MyLessonInfo}>
                    <img className={classes.MyLessonInfoImg} src={lessonDetails?.assessment?.id ? AssessmentIcon : UnAssessmentIcon} alt="icon" />
                    <div className={classes.MyLessonInfoText}>
                        {texts.toThisLesson}
                        <div className={classes.Highlight}>{lessonDetails?.assessment?.id ? texts.connectedAssessment : texts.notConnectedAssessment}</div>
                        {texts.toSubmit}.</div>
                </div>
            </div>
        </div>
    )
})

export default ExposeNFinalLesson 